import React from 'react';
import PropTypes from 'prop-types';
import searchResultLayout from '../constants/searchResultLayoutConstants';
import searchConstants from '../constants/searchConstants';

function SearchResultHeader({
  translate,
  originalKeyword,
  correctedKeyword,
  filteredKeyword,
  suggestedKeyword,
  searchRevertedKeyword,
  searchSuggestedKeyword
}) {
  const onClickSearchRevertedKeyword = () => {
    searchRevertedKeyword(originalKeyword, false);
  };

  const onClickSearchSuggestedKeyword = () => {
    searchSuggestedKeyword(suggestedKeyword);
  };

  const displayKeyword = !correctedKeyword ? originalKeyword : correctedKeyword;
  return (
    <div className='search-result-header'>
      {!searchConstants.isAutocompleteSuggestionsIXPTestEnabled && (
        <div className='text'>
          {translate(searchResultLayout.searchResultLabel)}
          <span className='text-emphasis font-bold search-query-text'>
            {filteredKeyword || displayKeyword}
          </span>
        </div>
      )}
      {correctedKeyword?.length > 0 && (
        <div className='small text'>
          {translate(searchResultLayout.searchInsteadForLabel)}

          <span
            className='small cursor-pointer text-link original-keyword'
            onClick={onClickSearchRevertedKeyword}
            role='button'
            aria-hidden>
            {originalKeyword}
          </span>
        </div>
      )}
      {suggestedKeyword?.length && (
        <div className='small text'>
          {translate(searchResultLayout.searchSuggestedKeyworkLabel)}
          <span
            className='small cursor-pointer text-link original-keyword'
            onClick={onClickSearchSuggestedKeyword}
            role='button'
            aria-hidden>
            {suggestedKeyword}
          </span>
        </div>
      )}
    </div>
  );
}

SearchResultHeader.defaultProps = {
  originalKeyword: null,
  correctedKeyword: null,
  filteredKeyword: null,
  suggestedKeyword: null,
  searchRevertedKeyword: () => {
    return false;
  },
  searchSuggestedKeyword: () => {
    return false;
  }
};

SearchResultHeader.propTypes = {
  translate: PropTypes.func.isRequired,
  originalKeyword: PropTypes.string,
  correctedKeyword: PropTypes.string,
  filteredKeyword: PropTypes.string,
  suggestedKeyword: PropTypes.string,
  searchRevertedKeyword: PropTypes.func,
  searchSuggestedKeyword: PropTypes.func
};

export default SearchResultHeader;
